import { Component, OnInit } from '@angular/core';
import { GlobalEventsManager } from '../app-global-events-manager';

@Component({
  selector: 'app-mobile-redirection',
  templateUrl: './mobile-redirection.component.html',
  styleUrls: ['./mobile-redirection.component.scss']
})
export class MobileRedirectionComponent implements OnInit {

  constructor( private globalEventsManager: GlobalEventsManager) { }

  ngOnInit() {
    this.globalEventsManager.showNavBarSeller(true);
    this.globalEventsManager.showNavBarWorker(false);
    this.globalEventsManager.showNavBar(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/mobile-redirection/mobile-redirection.component.ts